import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';

@Component({
  selector: 'app-ui-allform-list',
  templateUrl: './ui-allform-list.component.html',
  styleUrls: ['./ui-allform-list.component.scss'],
})
export class UiAllformListComponent extends BaseListCtl {
  /**
   * ID of the application to which this form belongs.
   */
  public appId: number = 0;
  public usecaseId: number = 0;
  public isArchivedlistTabActive: boolean = false;
  public isTrashTabActive: boolean = false;
  allFormId: any;
  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super('', locator, route);
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
        let keySuffix = _self.locator.config.get('CONTEXT_PATH') + '-';
        const ctx: any = localStorage.getItem(keySuffix + 'userContext');
        this.form.searchParams['orgId'] = ctx.orgId;
        _self.searchbyid();
      });
    _self.allFormId = this.route.snapshot.paramMap.get('id');

    _self.searchArchived();
    _self.searchTrash();
  }

  /**
   * Initialize the component.
   */
  override ngOnInit(): void {
    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        super.ngOnInit();
      });
  }

  /**
   * Populate the form with the data from the API response.
   * @param form
   * @param data
   */
  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.subtitle = data.subtitle;
    form.description = data.description;
    form.userstoryId = data.userstoryId;
    form.code = data.code;
    form.description = data.description;
    form.columns = data.columns;
    form.fields = data.fields;
  }

  /**
   * Adds or toggles the form display status on the dashboard.
   * @param id
   * @param callback -
   */
  async addDashboard(id: any, callback?: any) {
    let _self = this;
    // Check if the ID is valid (non-null and non-zero).
    if (!id || id == 0) {
      if (callback) {
        callback();
      }
      return;
    }
    this.locator.config
      .getProperty(_self.api.endpoint)
      .then((property: string) => {
        let url = _self.api.get + '/' + id;
        this.locator.http.get(url, async function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;

          if (res.success) {
            _self.form.data.id = id;
            // Use a default value of 0 if 'showDashboard' is undefined
            const isDashboardVisible = res.result.data['showDashboard'] ?? 0;
            await _self.populateForm(_self.form.data, res.result.data);
            // Access the current 'showDashboard' status from the form data.
            // Toggle 'showDashboard': set to 1 if it's currently 0, or to 0 if it's 1.
            // - If it's null or 0 (not displayed), set it to 1 (visible).
            // - If it's 1 (visible), set it to 0 (not displayed).
            _self.form.data['showDashboard'] = isDashboardVisible === 0 ? 1 : 0;
            _self.save();
            if (callback) {
              callback();
            }
          }
        });
      });
  }

  /**
   * Search for forms by icon
   */
  // iconSearch() {
  //   let _self = this;
  //   _self.form.error = [];
  //   _self.form.message = '';
  //   _self.form.searchParams = {};
  //   _self.form.searchParams['showDashboard'] = 1;
  //   _self.search();
  // }
  isDashboardFilterActive = false; // 👈 initially false rakho

  iconSearch() {
    this.isDashboardFilterActive = !this.isDashboardFilterActive;
    console.log('isDashboardFilterActive', this.isDashboardFilterActive);

    if (this.isDashboardFilterActive) {
      this.form.searchParams['showDashboard'] = 1;
    } else {
      delete this.form.searchParams['showDashboard'];
    }

    this.search();
  }

  /**
   * Routed to the form page
   * @param apiId
   */
  gotoForm(apiId: number) {
    let _self = this;
    _self.forward('uiformlist/' + apiId);
  }

  /**
   * switch main and archive
   * @param tab
   */
  toggleTab(tab: string): void {
    this.isArchivedlistTabActive = tab === 'archivedlist';
    this.isTrashTabActive = tab === 'trashlist';
    if (this.isTrashTabActive) {
      this.isArchivedlistTabActive = true;
    }
  }

  /**
   * searchArchived
   * @param callback
   */
  async searchArchived(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/searchArchived/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              const allData = res.result.data;
              const applicationId = _self.allFormId;

              console.log('Application ID from route:', applicationId);
              console.log('Example archived form:', allData[0]);
              console.log('All keys:', Object.keys(allData[0]));

              // ✅ Filter forms by applicationId
              const filteredData = applicationId
                ? allData.filter(
                    (item: any) => item.applicationId == applicationId
                  )
                : allData;

              //_self.form.archivedlist = res.result.data;
              _self.form.archivedlist = filteredData;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          }
        );
      });
  }

  /**
   * searchArchived
   * @param callback
   */
  async searchTrash(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/searchTrash/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.trashlist = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          }
        );
      });
  }

  /**
   * Retrieve a record and execute callback after deletion
   *
   * @param id
   * @param callback
   */
  async retrieve(id: any, callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.isConfirmDelete = true;
    if (id && id > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }

        let url =
          this.locator.config.get('endpoint.ui.forms') + '/retrieve/' + id;
        this.locator.http.get(url, async function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.message = 'Data is retrieved';
            _self.searchArchived();
            _self.search();
            if (callback) {
              callback(res, error);
            }
          }
        });
      }
    }
  }

  override search(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    _self.form.searchParams['appId'] = Number(_self.allFormId);

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/search/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }
              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            // Assign list and pagination values whether success or not
            _self.form.list = res.result.data || [];
            _self.form.pageCount = res.result.pageCount;
            _self.form.pageSize = res.result.pageSize;
            _self.form.pageNos = _self.form.pageNo;
            _self.form.pageNoList = [];

            // Build page number list
            for (let i = 0; i < _self.form.pageCount; i++) {
              _self.form.pageNoList.push(i);
            }

            // Check for empty list and set message
            if (!_self.form.list || _self.form.list.length === 0) {
              _self.form.message = 'No record found.';
              _self.form.error = true;
              setTimeout(() => {
                _self.form.error = false;
                _self.form.message = '';
              }, 3000);
            }

            if (res.success) {
              // Optionally initialize datatable here
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            } else {
              // Show error message if available
              _self.form.message = res.result.message || 'Something went wrong';
              _self.form.error = true;
            }

            // Final callback
            if (callback) {
              callback();
            }
          }
        );
      });
  }

  searchbyid(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';
    const payload = {
      appId: Number(_self.allFormId),
      orderBy: 'name',
      pageSize: _self.form.pageSize,
    };

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/search/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(url, payload, function (res: any, error: any) {
          if (error) {
            if (callback) {
              callback(error);
            }

            return;
          }

          _self.form.searchError = !res.success;
          _self.form.searchMessage = res.result['message'];

          if (res.success) {
            _self.form.list = res.result.data;
            _self.form.pageCount = res.result.pageCount;
            _self.form.pageSize = res.result.pageSize;
            _self.form.pageNos = _self.form.pageNo;
            _self.form.pageNoList = [];
            //Build page number list
            for (let i = 0; i < _self.form.pageCount; i++) {
              _self.form.pageNoList.push(i);
            }

            //Check empty list
            if (_self.form.list.length == 0) {
              _self.form.message = 'No record found';
              _self.form.error = true;
            }

            // Add data in Datatable
            //_self.initializeDataTable();

            if (callback) {
              callback();
            }
          } else {
            _self.form.list = [];
          }

          if (callback) {
            callback();
          }
        });
      });
  }

  // override search(callback?: any) {

  //   var _self = this;

  //   _self.form.searchError = false;
  //   _self.form.searchMessage = '';
  //   const payload = {
  //     appId: Number(_self.allFormId),
  //     orderBy: 'name',
  //     pageSize:_self.form.pageSize

  //   };

  //   this.locator.config
  //     .getProperty('endpoint.ui.forms')
  //     .then((property: string) => {
  //       let url = property + '/search/' + _self.form.pageNo;
  //       _self.form.searchParams['pageSize'] = _self.form.pageSize;

  //       this.locator.http.post(
  //         url,
  //         payload,
  //         function (res: any, error: any) {
  //           if (error) {
  //             if (callback) {
  //               callback(error);
  //             }

  //             return;
  //           }

  //           _self.form.searchError = !res.success;
  //           _self.form.searchMessage = res.result['message'];

  //           if (res.success) {
  //             _self.form.list = res.result.data;
  //             _self.form.pageCount = res.result.pageCount;
  //             _self.form.pageSize = res.result.pageSize;
  //             _self.form.pageNos = _self.form.pageNo;
  //             _self.form.pageNoList = [];
  //             //Build page number list
  //             for (let i = 0; i < _self.form.pageCount; i++) {
  //               _self.form.pageNoList.push(i);
  //             }

  //             //Check empty list
  //             if (_self.form.list.length == 0) {
  //               _self.form.message = 'No record found';
  //               _self.form.error = true;
  //             }

  //             // Add data in Datatable
  //             //_self.initializeDataTable();

  //             if (callback) {
  //               callback();
  //             }
  //           }

  //           if (callback) {
  //             callback();
  //           }
  //         }
  //       );
  //     });
  // }

  dropdownOpen: boolean = false;

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectApp(value: string) {
    this.form.searchParams['applicationName'] = value;
    this.dropdownOpen = false;

    // Call the search method after selecting the application
    this.search();
  }

  // sortedField: string | null = null;
  // sortOrder: 'ASC' | 'DESC' | null = null;
  // sortTable(field: string): void {
  //   let _self = this;
  //   if (this.sortedField === field) {
  //     this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
  //   } else {
  //     this.sortedField = field;
  //     this.sortOrder = 'ASC';
  //   }
  //   _self.form.searchParams['orderBy'] = this.sortedField;
  //   _self.form.searchParams['asc'] = this.sortOrder;
  //   this.search();
  // }
  sortedField: string | null = null;
  sortOrder: 'ASC' | 'DESC' | null = null;

  sortTable(field: string): void {
    let _self = this;

    // Update sorting state
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }

    // Set sorting parameters
    _self.form.searchParams['orderBy'] = this.sortedField;
    _self.form.searchParams['asc'] = this.sortOrder;

    // Call appropriate search method based on active tab
    if (this.isTrashTabActive) {
      // Trash tab is active
      this.searchTrash();
    } else if (this.isArchivedlistTabActive) {
      // Archived tab is active (but not trash)
      this.searchArchived();
    } else {
      // Main list is active (default)
      this.search();
    }
  }
}
